import Cookies from 'js-cookie';

/**
 * Sets a cookie with a specified name and value, and an optional time-to-live (TTL) in seconds.
 *
 * @param {string} cookieName - The name of the cookie to set.
 * @param {string} value - The value to store in the cookie.
 * @param {number} [TTL=5] - The time-to-live for the cookie in seconds. Defaults to 5 seconds.
 */
export const setCookieWithTTL = (cookieName, value, TTL = 5) => {
  const now = new Date();
  now.setSeconds(now.getSeconds() + TTL);

  Cookies.set(cookieName, value, { expires: now });
};
